module.exports = __webpack_public_path__ + "img/firefox-2.5bc7aca5.svg";